import React from "react";
import { ERR_UNABLE_TO_HANDLE_REQUEST } from "../../ErrorMessages";
import settings from "../../settings";

const getSalesMessage = () =>
  `Please contact Sales at ${
    settings.phoneNumber[settings.appName]
  } (Option 1) for information about reactivating.`;

const getCustomerCareMessage = () =>
  `Please contact Customer Service at ${
    settings.phoneNumber[settings.appName]
  } (Option 2) for more information.`;

const getAccountingMessage = () =>
  `Please contact Accounting at ${
    settings.phoneNumber[settings.appName]
  } (Option 3) for more information.`;

export const getUnableToHandleRequestElement = () => (
  <span>
    <nobr>We apologize we could not handle your request at this time. </nobr>
    <br /> Please try again later.
    <br />
  </span>
);

export const getInsufficientElement = (errMsg) => {
  if (
    errMsg.indexOf("Invalid Address") !== -1 ||
    errMsg.indexOf("sufficient") !== -1 ||
    errMsg.indexOf("1000") !== -1 ||
    errMsg.indexOf("More then ") !== -1
  ) {
    const messageElements = [];
    messageElements.push(errMsg);
    messageElements.push(<br />);
    if (errMsg.indexOf("sufficient") === -1) {
      messageElements.push("Insufficient information to perform search.");
      messageElements.push(<br />);
    }
    messageElements.push(<br />);
    messageElements.push(
      "Adding information such as State, City or SSN will narow down the search."
    );
    messageElements.push(<br />);
    return <span>{messageElements}</span>;
  }
  return null;
};

export const getLoginMessage = (status, attemptCounter = "0") => {
  const upperCaseStatus = status.toUpperCase();
  if (upperCaseStatus === "IP_RESTRICTED") {
    return "User IP restricted";
  }
  if (upperCaseStatus === "PASSWORD_ERROR") {
    return `The PASSWORD entered does not match our records.   Please note that passwords are case sensitive.  Your account will be locked after ${attemptCounter} failed attempts. If you continue to experience issues, please contact customer service for assistance.`;
  }
  if (upperCaseStatus === "EXPIRED") {
    return "Your password has expired. Please enter your username and email address and click RESET button. An email with the secure link will be sent to your email address. Please use the provided link.";
  }
  if (upperCaseStatus === "EXPIRED_NEW") {
    return "This link has expired. A newer link has been sent to you.  Please use the provided link.";
  }
  if (upperCaseStatus === "USERNAME") {
    return "The User ID entered does not match our records (UN).  Please ensure you entered the correct User ID.  If you continue to experience issues, please contact customer service for assistance.";
  }
  if (upperCaseStatus === "NOU") {
    return "The User ID entered does not match our records (NOU).  Please ensure you entered the correct User ID.  If you continue to experience issues, please contact customer service for assistance.";
  }
  if (upperCaseStatus === "RESET") {
    return `Looks like you don't remember your password. Please reset it. ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "EMP") {
    return "No User ID was provided or your session has expired. Please ensure you entered the correct User ID.  If you continue to experience issues, please contact customer service for assistance.";
  }
  if (upperCaseStatus === "CLOSED") {
    return `Your account is closed. ${getSalesMessage()}`;
  }
  if (upperCaseStatus === "DISABLED") {
    return `Your User ID is disabled. ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "LOCKED") {
    return `Your User ID has been locked. ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "RESTRICTED") {
    return (
      <span>
        {`Your account has been restricted due to non-payment. ${getAccountingMessage()}`}
      </span>
    );
  }
  if (upperCaseStatus === "REST_AUDIT") {
    return `Your account is under review. ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "AUDIT_LOCK") {
    return `Your account has been marked for review by our automated system. ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "DIS_NP") {
    return (
      <span>
        {`Your account has been disabled due to non-payment. ${getAccountingMessage()}`}
      </span>
    );
  }
  if (upperCaseStatus === "DIS_SI") {
    return `Your account is disabled. ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "DIS_HU") {
    return `Your account is disabled due to high usage. ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "CANCEL") {
    return `Your account is cancelled, but reactivation options still exist. ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "BAS") {
    return `There is a problem with your account (103). ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "MAXCONCURRENT") {
    return `All licenses on your account are currently being used. Please try again later.`;
  }
  if (upperCaseStatus === "ERROR") {
    return `Internal server error. ${getCustomerCareMessage()}`;
  }
  if (upperCaseStatus === "CHANGE") {
    return `An email with the secure link has been sent to you. Please use the provided link.`;
  }
  if (upperCaseStatus === "NEW") {
    return `Please enter your username and email address and click RESET button. An email with the secure link will be sent to your email address. Please use the provided link.`;
  }
  return "";
};

export const getErrorMessage = (errMsg, reportName) => {
  const upperCaseErrMsg = errMsg.toUpperCase();
  if (upperCaseErrMsg === "MAXLIVEREACHEDCANTRUNLIVESEARCH")
    return "You have reached maximum number of live searches available per hour.";
  if (upperCaseErrMsg === "BLOCKEDACCOUNTCANTRUNLIVESEARCH")
    return "Your acount is not eligible for live searches.";
  if (upperCaseErrMsg === "REPORTTIMEOUT")
    return "We are sorry, the report is unavailable. We are working on it. Please try again later.";
  if (upperCaseErrMsg === "CANTRUNLIVESEARCH")
    return "You are not authorised to run live search.";
  if (upperCaseErrMsg === "CLOSED") {
    return `Your account is closed. ${getSalesMessage()}`;
  }
  if (upperCaseErrMsg === "REST_AUDIT") {
    return `Your account is under review. ${getCustomerCareMessage()}`;
  }
  if (upperCaseErrMsg === "RESTRICTED") {
    return (
      <span>
        {`Your account has been restricted due to non-payment. ${getAccountingMessage()}`}
      </span>
    );
  }
  if (upperCaseErrMsg === "DIS_NP") {
    return (
      <span>
        {`Your account has been disabled due to non-payment. ${getAccountingMessage()}`}
      </span>
    );
  }
  if (upperCaseErrMsg === "DIS_SI") {
    return `Your account is disabled. ${getCustomerCareMessage()}`;
  }
  if (upperCaseErrMsg === "DIS_HU") {
    return `Your account is disabled due to high usage. ${getCustomerCareMessage()}`;
  }
  if (upperCaseErrMsg === "CANCEL") {
    return `Your account is cancelled, but reactivation options still exist. ${getCustomerCareMessage()}`;
  }
  if (upperCaseErrMsg === "BAS") {
    return `There is a problem with your account (103). ${getCustomerCareMessage()}`;
  }
  if (upperCaseErrMsg === "OVERLIMIT")
    return (
      <span>
        You have used all your free{" "}
        {!reportName || reportName.indexOf("Report") === -1
          ? "Searches"
          : reportName.toUpperCase()}{" "}
        <br /> Contact your sales rep at (877) 482-0101 to discuss activating
        your full membership.
      </span>
    );
  if (upperCaseErrMsg === "NOTACTIVEACCOUNT")
    return "Your account is not active.";
  if (upperCaseErrMsg === "AUDITLOCKED")
    return `Your account has been marked for review by our automated system. ${getCustomerCareMessage()}`;

  if (upperCaseErrMsg === "MULTIPLEUSERS")
    return "This user ID is being used from different location/browser at the moment.";
  if (
    upperCaseErrMsg ===
    "THE SSN ENTERED WAS NOT FOUND IN OUR DATABASE. PLEASE CHECK THE NUMBER AND TRY AGAIN."
  )
    return "No Records Found.";
  if (upperCaseErrMsg === "INVALID SS NUMBER. POSSIBLE ITIN DETECTED.")
    return "Invalid SSN. Possible Individual Tax ID Number.";
  if (upperCaseErrMsg === "NOT ENOUGH MONEY TO SEARCH.")
    return ERR_UNABLE_TO_HANDLE_REQUEST;
  if (upperCaseErrMsg === "EMPTYACTIVITYDESC")
    return "The search/report request is invalid. Please try again.";
  if (errMsg.indexOf(":") !== -1 && errMsg.indexOf("]") !== -1) {
    errMsg = errMsg.substring(errMsg.indexOf(":") + 1);
    return errMsg.substring(0, errMsg.indexOf("]"));
  }
  if (
    errMsg.indexOf("Invalid request") !== -1 ||
    errMsg.indexOf("Invalid Address") !== -1 ||
    errMsg.indexOf("sufficient") !== -1 ||
    errMsg.indexOf("1000") !== -1 ||
    errMsg.indexOf("More then ") !== -1
  )
    return errMsg;
  if (errMsg.indexOf("TransUnion") !== -1) return ERR_UNABLE_TO_HANDLE_REQUEST;
  return "";
};

export default getLoginMessage;



// WEBPACK FOOTER //
// ./src/components/messages/errorMessages.js